<template>
  <div class = "Verify-wrapper">
    <el-container>
      <el-header class="Verify_header">
          <p>一网通办校外用户办事入口</p>
      </el-header>
      <el-main>
        <div id = "Verify">
          <span class="spandiv">
            <div class="sdyulogo">
              <img fit="contain" src="../assets/img/qlu_logo.png"/>
            </div>
          </span>
          <span class="spandiv">
            <button class="buttenStyle" @click="jumpSMJXLC">
              <el-row :gutter="20">
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <i class="el-icon-search el-icon--right"></i>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    档案查询申请
                  </div>
                </el-col>
              </el-row>
            </button>
          </span>
          <span class="spandiv">
            <button  class="buttenStyle" @click="clickVerify">
              <el-row :gutter="20">
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <i class="el-icon-s-claim el-icon--right"></i>
                  </div>
                </el-col>
                <el-col :span="16">
                  <div class="grid-content bg-purple">
                    校外人员入校申请
                  </div>
                </el-col>
              </el-row>
            </button>
          </span>
          <span class="spandiv">
            <button  class="buttenStyle" @click="jumpXWBYSQ">
                本专科学士学位证明书、毕业证明书<br/>补办申请
            </button>
          </span>

          <span class="spandiv">
            <button class="buttenStyle" @click="jumpProofSeal">
                本专科学生相关证明教务处用印申请
            </button>
            <span class="text_tip">提示：适用于本专科毕业证、学位证英文翻译证明、中英文成绩类相关证明等</span>
          </span>

          <span class="spandiv">
            <button  class="buttenStyle" @click="jumpXSNJSL">
                校史、年鉴申领
            </button>
          </span>
        </div>
      </el-main>

      <div class="Verify_footer">
        Copyright@齐鲁工业大学（山东省科学院）
      </div>
    </el-container>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        imgurl: './src/assets/img/qlu_logo.png',
        fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
        userid: "",
        daurl:"",
      }
    },
    methods: {
      // 入校申请
      clickVerify(){
        sessionStorage.setItem("SQName","/home");
        this.$router.push({path: "/login"});
      },
      // 档案查询申请
      jumpSMJXLC(){
        sessionStorage.setItem("SQName","/arch");
        this.$router.push({path: "/login"});
      },
      // 学位毕业证明申请
      jumpXWBYSQ(){
        sessionStorage.setItem("SQName","/aca");
        this.$router.push({path: "/login"});
      },
      // 学生相关证明用印审批
      jumpProofSeal(){
        sessionStorage.setItem("SQName","/Pro");
        this.$router.push({path: "/login"});
      },
      //校史、年鉴申领
      jumpXSNJSL(){
        sessionStorage.setItem("SQName","/XSNJSL");
        this.$router.push({path: "/login"});
      }
    }
  }
</script>

<style scoped>
  .Verify-wrapper {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
  }
  #Verify {
      max-width: 340px;
      margin: 60px auto;
      background: #fff;
      padding: 20px 40px;
      border-radius: 10px;
      position: relative;
      z-index: 9;
  }
  #Verify span{
    display: block;
    padding: 10px;
  }
  .el-form-item {
    text-align: center;
  }

  .code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .code button {
    margin-left: 20px;
    width: 140px;
    text-align: center;
  }
  .Verify_header{
      background-color: #004387;
      text-align: center;
      color: #ffffff;
      font-size: 120%;
  }
  .inputwidth {
    width: 100%;
  }
  .sdyulogo{
    width: 100%;
  }
  .sdyulogo img{
      width: 100%;
    }

  .Verify_footer{
    background-color: #004387;
    color: #ffffff;
    text-align: center;
    font-size: 75%;
    position:fixed;
    bottom:0;
    width: 100%;
    height: 20px;
    margin: 0px;
  }
  .buttenStyle{
    color: #004387;
    background-color: #fff;
    border: 1px solid #004387;
    border-radius: 4px;
    height: auto;
    width: 100%;
    padding: 10px;
  }
  /* 鼠标点击时 */
  /* .buttenStyle:focus {
    background: #0253a5;
    border: 1px solid #0367ca;
    color: #ffffff;
  } */
  /* 鼠标放上去时 */
  .buttenStyle:hover{
    background: #00438788;
    border: 1px solid #fff;
    color: #fff;
  }
  .buttenStyle i{
    color: #fff;
    font-size: 120%;
    right: 0;
  }
  butten{
    box-shadow: none;
  }
  .visitor_header {
      background-color: #004387;
      /* opacity: 0.5; */
      text-align: center;
      color: #ffffff;
      font-size: 120%;
    }
  .visitor_footer{
    position:fixed;
    bottom:30px;
    text-align:center;
    width: 100%;
    }
    .hisButt{
      background-color: #EBEEF5;
    }
  .text_tip {
    font-size: 50%;
    padding: 0px !important;
    color: #004387aa;
  }
</style>
